"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromiseCacheObservable = exports.DeferredGetter = void 0;
const mobx_1 = require("mobx");
const promiseCache_1 = require("@zajno/common/structures/promiseCache");
var promiseCache_2 = require("@zajno/common/structures/promiseCache");
Object.defineProperty(exports, "DeferredGetter", { enumerable: true, get: function () { return promiseCache_2.DeferredGetter; } });
class PromiseCacheObservable extends promiseCache_1.PromiseCache {
    constructor(fetcher, keyAdapter, keyParser, observeItems = false) {
        super(fetcher, keyAdapter, keyParser);
        this._observeItems = false;
        (0, mobx_1.makeObservable)(this, {
            _busyCount: mobx_1.observable,
            _itemsCache: mobx_1.observable.shallow,
            _itemsStatus: mobx_1.observable,
            setStatus: mobx_1.action,
            setPromise: mobx_1.action,
            onBeforeFetch: mobx_1.action,
            storeResult: mobx_1.action,
            onFetchComplete: mobx_1.action,
            _set: mobx_1.action,
        });
        this._observeItems = observeItems;
    }
    useObserveItems(observeItems) {
        this._observeItems = observeItems;
        return this;
    }
    prepareResult(res) {
        return res
            ? (this._observeItems ? mobx_1.observable.object(res) : res)
            : null;
    }
}
exports.PromiseCacheObservable = PromiseCacheObservable;
//# sourceMappingURL=promiseCache.js.map